import { Base } from './_base.model';

export class StaffShadowSchedule extends Base {
  id: number;
  staff_id: string;
  start_at: Date;
  end_at: Date;
}
